import { render, staticRenderFns } from "./PropertyDetail.vue?vue&type=template&id=25c3807c"
import script from "./PropertyDetail.vue?vue&type=script&lang=ts"
export * from "./PropertyDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports